// extracted by mini-css-extract-plugin
export default {"form":"SearchBar_form__nhKdH","button":"SearchBar_button__HF4Xz","card":"SearchBar_card__2d-MF"};